import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Button from "@pathwright/ui/src/components/button/Button"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import { DROP_TYPE_PATH } from "../constants"
import * as PathUI from "../ui/PathUI"
import EditPathAddItem from "./EditPathAddItem"
import EditPathDivider from "./EditPathDivider"
import EditPathLesson from "./EditPathLesson"
import EditPathResource from "./EditPathResource"
import EditPathStep from "./EditPathStep"

const EditPathList = (props) => {
  const {
    path,
    error,
    loading,
    items,
    hasMore,
    loadMore,
    onDragStart,
    onDragEnd
  } = props
  return (
    <PathUI.PathListCointainer>
      {error ? (
        <BlankSlate
          icons={null}
          heading="An unexpected error occurred"
          inverted
          body={(error && error.message) || error}
        />
      ) : loading && !path ? (
        <LoadingCircle inverted />
      ) : (
        <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
          <Droppable droppableId={path.id + ""} type={DROP_TYPE_PATH}>
            {(provided, droppableSnapshot) => (
              <PathUI.PathListWrapper
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {items.map((pathItem, index) => (
                  <Draggable
                    key={pathItem.id}
                    type={DROP_TYPE_PATH}
                    draggableId={pathItem.id + ""}
                    index={index}
                  >
                    {(provided, draggableSnapshot) => (
                      <li>
                        {!droppableSnapshot.isDraggingOver && (
                          <EditPathAddItem index={index + 1} pathId={path.id} />
                        )}
                        <PathUI.PathItemWrapper
                          ref={provided.innerRef}
                          isDragging={draggableSnapshot.isDragging}
                          spacing={20}
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                        >
                          {pathItem.type === "divider" ? (
                            <EditPathDivider pathItem={pathItem} />
                          ) : pathItem.type === "lesson" ? (
                            <EditPathLesson pathItem={pathItem} />
                          ) : pathItem.type === "resource" ? (
                            <EditPathResource pathItem={pathItem} />
                          ) : pathItem.type === "step" ? (
                            <EditPathStep pathItem={pathItem} />
                          ) : null}
                        </PathUI.PathItemWrapper>
                      </li>
                    )}
                  </Draggable>
                ))}
                {!droppableSnapshot.isDraggingOver && (
                  <EditPathAddItem index={items.length + 1} pathId={path.id} />
                )}
                {provided.placeholder}
                {props.hasMore && (
                  <PathUI.PathLoadMoreWrapper>
                    {props.loading ? (
                      <LoadingCircle inverted />
                    ) : (
                      <Button
                        styleType="empty"
                        inverted
                        onClick={props.loadMore}
                      >
                        Load More
                      </Button>
                    )}
                  </PathUI.PathLoadMoreWrapper>
                )}
              </PathUI.PathListWrapper>
            )}
          </Droppable>
        </DragDropContext>
      )}
    </PathUI.PathListCointainer>
  )
}

EditPathList.displayName = "EditPathList"

EditPathList.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired
}

export default EditPathList
